import { Checkbox, Stack } from '@chakra-ui/react';
import { EntityType } from '@texas/api/endpoints/trackerApi';
import { entityTypeFriendlyName } from '../shared/tracker/translations';
import { useTranslation } from 'react-i18next';

const entityTypes = Object.values(EntityType).filter(
  (v): v is EntityType => typeof v === 'number',
);

export function EntityTypeCheckboxes() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2}>
      {entityTypes.map((type) => (
        <Checkbox key={type} value={String(type)}>
          {entityTypeFriendlyName(t, type)}
        </Checkbox>
      ))}
    </Stack>
  );
}
